import moment from "moment";
import { BACKEND_LOCAL } from "../constants";
import { CHART_LIMIT } from "../constants";
import styled from "styled-components";
import {TableCell, tableCellClasses,TableRow} from "@mui/material";

export function getBackendUrl() {
    const urlAtual = window.location.host;

    if (urlAtual.indexOf("localhost") !== -1) {
        return BACKEND_LOCAL;
    }

    return "";
}

export const delay = ms => new Promise(res => setTimeout(res, ms));

export const irradianciasMap = {
        3: "Horizontal",
        2: "Refletida",
        1: "Inclinada",
    }

export const monthMap = {
    Jan: '01', Fev: '02', Mar: '03', Abr: '04', Mai: '05', Jun: '06',
    Jul: '07', Ago: '08', Set: '09', Out: '10', Nov: '11', Dez: '12'
};

function divideArrayEm3(arr) {
    let partes = [],
        i = 0,
        n = arr.length;
    while (i < n) {
        partes.push(arr.slice(i, (i += arr.length / 3)));
    }
    return partes;
}

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#0a5068",
        color: "#fff",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: "#e9ecef",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

export function obterDadosDistribuidos(inversorData) {
    if (inversorData.length <= CHART_LIMIT) {
        return inversorData;
    }

    const inversorParts = divideArrayEm3(inversorData);
    let distributedData = [];

    // obtendo os primeiros dados da primeira metade do inversor
    for (let i = 0; i < Math.ceil(CHART_LIMIT / 3); i++) {
        distributedData.push(inversorParts[0][i]);
    }

    // obtendo os primeiros dados da segunda metade do inversor
    for (let i = 0; i < Math.floor(CHART_LIMIT / 3 / 2); i++) {
        distributedData.push(inversorParts[1][i]);
    }

    // obtendo os últimos dados da segunda metade do inversor
    for (
        let i = inversorParts[1].length - Math.ceil(CHART_LIMIT / 3 / 2);
        i < inversorParts[1].length;
        i++
    ) {
        if (distributedData.length < CHART_LIMIT - Math.floor(CHART_LIMIT / 3)) {
            // se o tamanho não excedeu o espaço de 2 terços do CHART_LIMIT
            distributedData.push(inversorParts[1][i]);
        }
    }

    // obtendo os últimos dados da terceira e última metade do inversor
    const tamanho =
        distributedData.length === CHART_LIMIT - Math.floor(CHART_LIMIT / 3)
            ? Math.floor(CHART_LIMIT / 3)
            : Math.floor(CHART_LIMIT / 3) + 1;
    for (let i = inversorParts[2].length - tamanho; i < inversorParts[2].length; i++) {
        distributedData.push(inversorParts[2][i]);
    }

    return distributedData;
}

export function formatarData(datahora) {
    const data = datahora.split(".")[0].split("T")[0].split("-");
    const hora = datahora.split(".")[0].split("T")[1].split(":");
    const dia = data[2];
    const mes = data[1];
    const ano = data[0];
    return `${dia}/${mes}/${ano[2]}${ano[3]} ${hora[0]}:${hora[1]}`;
}

export function converteParaHorarioLocal(data) {
    const date = new Date(data);

    var date_utc = Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
    );

    return date_utc;
}

export function formatEstacoesComAlbedo1(estacoes) {
        return estacoes.map((item) => {
            return {
                ...item,
                albedo1: item.estacaoAlbedos.find((albedo) =>  albedo.cod == 1)?.valor,
            };
        });
}

export function formatEstacaoComAlbedo1(estacao) {
    try{
        return {
            ...estacao,
            albedo1: estacao.estacaoAlbedos.find((albedo) => albedo.cod == 1).valor,
        };
    }catch{
        return {...estacao}
    }
}

export function formatEstacaoComDni3(estacao) {
    try{
        return {
            ...estacao,
            dni3: estacao?.estacaoDnis?.find((dni) => dni.cod == 3)?.valor,
        };
    }catch{
        return {...estacao}
    }
}

export function formatEstacoesComDni3(estacoes) {
        return estacoes.map((item) => {
            return {
                ...item,
                dni3: item?.estacaoDnis?.find((dni) => dni.cod == 3)?.valor,
            };
        });
}



export const cpfMask = (value) => {
    return value
        .replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
        .replace(/(\d{3})(\d)/, "$1.$2") // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})/, "$1-$2")
        .replace(/(-\d{2})\d+?$/, "$1"); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const formatUserProfile = (profile) => {
    if (profile === "RESPONSAVEL_USINA") return "Responsável da usina";
    if (profile === "PROPRIETARIO_USINA") return "Proprietário da usina";
    if (profile === "ADMIN") return "Admin";
};

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const formatAlarmes = (alarmes) => {
    return alarmes.map((item) => {
        const descricao = item.alarmeTipo?.descricao;
        const usina = item.usina?.nome;
        const cod = item.inversor
            ? item.inversor?.cod
            : item.tracker
            ? item.tracker?.cod
            : item.combiner
            ? item.combiner?.cod
            : null;

        const tipo_equipamento = capitalizeFirstLetter(item.alarmeTipo?.tipo_equipamento);
        const equipamento = `${tipo_equipamento} ${cod ? cod : ""} `;
        const status = item.data_fim ? "Inativo" : "Ativo";
        return {
            id: item.id,
            descricao,
            usina,
            equipamento,
            status,
            data_inicio: moment(item.data_inicio).format("DD/MM/YYYY HH:mm:ss"),
            data_fim: item.data_fim
                ? moment(item.data_fim).format("DD/MM/YYYY HH:mm:ss")
                : "Em andamento",
        };
    });
};

export const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
};

export const inverosorStatusEnum = {
    onGrid: 0,
    standby: 5120,
    starting: 5632,
    failure: 21760,
    offGrid: 4,
}

export const inversorChartOptions = {
    combiner: {
        label: "Combiner",
        mppts_power: "Potência MPPT",
        combiner_voltage_string: "Tensão String",
        combiner_corrente_string: "Correntes String"
    },
    measurer: {
        label: "Medidor",
        active_power: "Potência Ativa",
        consumed_energy: "Energia Consumida",
        injected_energy: "Energia Injetada",
    },
    inversor: {
        label: "Inversor",
        corrente_a: "Corrente A",
        corrente_b: "Corrente B",
        corrente_c: "Corrente C",
        corrente_max: "Corrente Máxima",
        corrente_media: "Corrente Média",
        corrente_total: "Corrente Total",
        eficiencia: "Eficiência",
        e_diaria: "Energia Diária",
        e_mensal: "Energia Mensal",
        e_total: "Energia Total",
        fp: "Fator de Potência (FP)",
        frequencia: "Frequência",
        pot_ativa_medidor: "Potência Ativa",
        pot_ativa: "Potência Ativa",
        pot_reativa: "Potência Reativa",
        potencia_total_ac: "Potência Total CA",
        potencia_total_dc: "Potência Total DC",
        temperatura_inv: "Temperatura do Inversor",
        tensao_a: "Tensão A",
        tensao_b: "Tensão B",
        tensao_c: "Tensão C",
        e_anual: "Energia Anual"
    },
    tracker: {
        label: "Tracker",
        angulo_real: "Ângulo Real",
        angulo_ideal: "Ângulo Ideal"
    },
    station: {
        label: "Estação Meteorológica",
        temperatura_ar: "Temperatura do Ar",
        estacao_temperatura_mod: "Temperatura do Painel",
        vento: "Velocidade do Vento",
        umidade: "Umidade"
    },
    rele: {
        label: "Relé",
        corrente_a: "Corrente A",
        corrente_b: "Corrente B",
        corrente_c: "Corrente C",
        fator_potencia_a: "Fator de Potência A",
        fator_potencia_b: "Fator de Potência B",
        fator_potencia_c: "Fator de Potência C",
        frequencia_linha: "Frequência da Linha",
        frequencia_barra: "Frequência da Barra",
        temperatura: "Temperatura",
        tensao_a: "Tensão A",
        tensao_b: "Tensão B",
        tensao_c: "Tensão C",
        potencia_ativa_a: "Potência Ativa A",
        potencia_ativa_b: "Potência Ativa B",
        potencia_ativa_c: "Potência Ativa C",
        potencia_aparente: "Potência Aparente",
        tensao_residual: "Tensão Residual"
    }
};

export const genericChartDefaultSelectOptions = [
    {
        key: 'combiner',
        label: 'Combiners',
        children: []
    },
    {
        key: 'inversor',
        label: 'Inversores',
        children: [
            { key: 'inversor-0-corrente_a', label: 'Corrente A' },
            { key: 'inversor-0-corrente_b', label: 'Corrente B' },
            { key: 'inversor-0-corrente_c', label: 'Corrente C' },
            // { key: 'inversor-0-corrente_max', label: 'Corrente Máxima' },
            // { key: 'inversor-0-corrente_media', label: 'Corrente Média' },
            // { key: 'inversor-0-corrente_total', label: 'Corrente Total' },
            { key: 'inversor-0-eficiencia', label: 'Eficiência' },
            { key: 'inversor-0-e_diaria', label: 'Energia Diária' },
            { key: 'inversor-0-e_mensal', label: 'Energia Mensal' },
            { key: 'inversor-0-e_total', label: 'Energia Total' },
            { key: 'inversor-0-fp', label: 'Fator de Potência (FP)' },
            { key: 'inversor-0-frequencia', label: 'Frequência' },
            { key: 'inversor-0-pot_ativa', label: 'Potência Ativa' },
            { key: 'inversor-0-pot_reativa', label: 'Potência Reativa' },
            { key: 'inversor-0-potencia_total_ac', label: 'Potência Total AC' },
            { key: 'inversor-0-potencia_total_dc', label: 'Potência Total DC' },
            { key: 'inversor-0-temperatura_inv', label: 'Temperatura do Inversor' },
            { key: 'inversor-0-tensao_a', label: 'Tensão A' },
            { key: 'inversor-0-tensao_b', label: 'Tensão B' },
            { key: 'inversor-0-tensao_c', label: 'Tensão C' }
        ]
    },
    {
        key: 'measurer',
        label: 'Medidor',
        children: [
            { key: 'measurer-0-consumed_energy', label: 'Energia consumida' },
            { key: 'measurer-0-injected_energy', label: 'Energia injetada' },
            { key: 'measurer-0-active_power', label: 'Potência Ativa' }
        ]
    },
    {
        key: 'tracker',
        label: 'Tracker',
        children: [
            { key: 'tracker-0-angulo_ideal', label: 'Ângulo Ideal' },
            { key: 'tracker-0-angulo_real', label: 'Ângulo Real' }
        ]
    },
    {
        key: 'station',
        label: 'Estação Meteorológica',
        children: [
            { key: 'station-0-temperatura_ar', label: 'Temperatura do Ar' },
            { key: 'station-0-estacao_temperatura_mod', label: 'Temperatura do Painel' },
            { key: 'station-0-umidade', label: 'Umidade' },
            { key: 'station-0-vento', label: 'Velocidade do Vento' }
        ]
    },
    {
        key: 'rele',
        label: 'Relé',
        children: [
            { key: 'rele-0-corrente_a', label: 'Corrente A' },
            { key: 'rele-0-corrente_b', label: 'Corrente B' },
            { key: 'rele-0-corrente_c', label: 'Corrente C' },
            { key: 'rele-0-fator_potencia_a', label: 'Fator de Potência A' },
            { key: 'rele-0-fator_potencia_b', label: 'Fator de Potência B' },
            { key: 'rele-0-fator_potencia_c', label: 'Fator de Potência C' },
            { key: 'rele-0-frequencia_barra', label: 'Frequência da Barra' },
            { key: 'rele-0-frequencia_linha', label: 'Frequência da Linha' },
            { key: 'rele-0-temperatura', label: 'Temperatura' },
            { key: 'rele-0-tensao_a', label: 'Tensão A' },
            { key: 'rele-0-tensao_b', label: 'Tensão B' },
            { key: 'rele-0-tensao_c', label: 'Tensão C' },
            { key: 'rele-0-potencia_ativa_a', label: 'Potência Ativa A' },
            { key: 'rele-0-potencia_ativa_b', label: 'Potência Ativa B' },
            { key: 'rele-0-potencia_ativa_c', label: 'Potência Ativa C' },
            { key: 'rele-0-potencia_aparente', label: 'Potência Aparente' },
            { key: 'rele-0-tensao_residual', label: 'Tensão Residual' }
        ]
    }]


export const colors = [
    {
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
    },
    {
        borderColor: "rgb(28, 44, 196)",
        backgroundColor: "rgb(28, 44, 196, 0.5)",
    },
    {
        borderColor: "rgb(0, 0, 250)",
        backgroundColor: "rgb(0, 0, 250, 0.5)",
    },
    {
        borderColor: "rgb(102, 102, 255)",
        backgroundColor: "rgb(102, 102, 255, 0.5)",
    },
    {
        borderColor: "rgb(153, 51, 255)",
        backgroundColor: "rgb(153, 51, 255, 0.5)",
    },
    {
        borderColor: "rgb(153, 0, 204)",
        backgroundColor: "rgb(153, 0, 204, 0.5)",
    },
    {
        borderColor: "rgb(204, 0, 204)",
        backgroundColor: "rgb(204, 0, 204, 0.5)",
    },
    {
        borderColor: "rgb(255, 0, 102)",
        backgroundColor: "rgb(255, 0, 102, 0.5)",
    },
    {
        borderColor: "rgb(255, 0, 0)",
        backgroundColor: "rgb(255, 0, 0, 0.5)",
    },
    {
        borderColor: "rgb(128, 0, 0)",
        backgroundColor: "rgb(128, 0, 0, 0.5)",
    },
    {
        borderColor: "rgb(204, 102, 0)",
        backgroundColor: "rgb(204, 102, 0, 0.5)",
    },
    {
        borderColor: "rgb(255, 153, 0)",
        backgroundColor: "rgb(255, 153, 0, 0.5)",
    },
    {
        borderColor: "rgb(204, 255, 51)",
        backgroundColor: "rgb(204, 255, 51, 0.5)",
    },
    {
        borderColor: "rgb(255, 255, 0)",
        backgroundColor: "rgb(255, 255, 0, 0.5)",
    },
    {
        borderColor: "rgb(255, 255, 153)",
        backgroundColor: "rgb(255, 255, 153, 0.5)",
    },
    {
        borderColor: "rgb(102, 255, 51)",
        backgroundColor: "rgb(102, 255, 51, 0.5)",
    },
    {
        borderColor: "rgb(0, 102, 0)",
        backgroundColor: "rgb(0, 102, 0, 0.5)",
    },
    {
        borderColor: "rgb(153, 255, 204)",
        backgroundColor: "rgb(153, 255, 204, 0.5)",
    },
    {
        borderColor: "rgb(0, 153, 153)",
        backgroundColor: " rgb(0, 153, 153, 0.5)",
    },
    {
        borderColor: "rgb(0, 102, 153)",
        backgroundColor: " rgb(0, 102, 153, 0.5)",
    },
    {
        borderColor: "rgb(102, 102, 153)",
        backgroundColor: "rgb(102, 102, 153, 0.5)",
    },
    {
        borderColor: "rgb(0, 0, 102)",
        backgroundColor: "rgb(0, 0, 102, 0.5)",
    },
    {
        borderColor: "rgb(102, 51, 0)",
        backgroundColor: "rgb(102, 51, 0, 0.5)",
    },
    {
        borderColor: "rgb(153, 153, 102)",
        backgroundColor: "rgb(153, 153, 102, 0.5)",
    },
    {
        borderColor: "rgb(204, 102, 153)",
        backgroundColor: "rgb(204, 102, 153, 0.5)",
    },
    {
        borderColor: "rgb(0, 255, 255)",
        backgroundColor: "rgb(0, 255, 255, 0.5)",
    },
    {
        borderColor: "rgb(255, 0, 255)",
        backgroundColor: "rgb(255, 0, 255, 0.5)",
    },
    {
        borderColor: "rgb(128, 255, 0)",
        backgroundColor: "rgb(128, 255, 0, 0.5)",
    },
    {
        borderColor: "rgb(255, 128, 0)",
        backgroundColor: "rgb(255, 128, 0, 0.5)",
    },
    {
        borderColor: "rgb(0, 128, 255)",
        backgroundColor: "rgb(0, 128, 255, 0.5)",
    },
    {
        borderColor: "rgb(255, 0, 128)",
        backgroundColor: "rgb(255, 0, 128, 0.5)",
    },
    {
        borderColor: "rgb(128, 0, 255)",
        backgroundColor: "rgb(128, 0, 255, 0.5)",
    },
    {
        borderColor: "rgb(0, 255, 128)",
        backgroundColor: "rgb(0, 255, 128, 0.5)",
    },
    {
        borderColor: "rgb(102, 255, 255)",
        backgroundColor: "rgb(102, 255, 255, 0.5)",
    },
    {
        borderColor: "rgb(204, 204, 255)",
        backgroundColor: "rgb(204, 204, 255, 0.5)",
    }
];


export function getRandomColors(numColors) {
  const colors = [];

  
  const randomComponent = () => Math.floor(Math.random() * 200);

  
  const generateRandomColor = () => {
    const borderColor = `rgb(${randomComponent()}, ${randomComponent()}, ${randomComponent()})`;
    const backgroundColor = `${borderColor.slice(0, -1)}, 0.5)`;
    return { borderColor, backgroundColor };
  };

  
  for (let i = 0; i < numColors; i++) {
    let color = generateRandomColor();

    
    while (colors.some(c => c.borderColor === color.borderColor && c.backgroundColor === color.backgroundColor)) {
      color = generateRandomColor();
    }

    colors.push(color);
  }

  return colors;
}

export function trackersAlarmsFilter(alarmes) {
        let result = new Map()
        alarmes.forEach((alarme) => {
            result.set(alarme.tracker.cod, true)
        })
        return result
    }

